// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 571 ? "b637e9a5" : chunkId) + "." + {"540":"63c7423a852c70b2","571":"98705244d5e9fc55","819":"1c3e2dff22865cea","823":"ece5527ecb9b7f9c","919":"1b9554964485afe3"}[chunkId] + ".js";
};